export const SYS_GENERATED_DOMAIN_LIST = 'ALLDOMAINS';
export const DOMAINS_MAX_DISPLAY_GRID_ENTRIES = 100000;
export const METADATA_MAX_DISPLAY_GRID_ENTRIES = 1000;
export const SMF_NO_TEXT_MESSAGE = '(no text)';
export const MAX_LIMIT_OF_RENDERED_QUERY = 4000;
export const TOAST_NOTIFICATION_TIMEOUT = 5000;
export const TOAST_ANIMATION_TIMEOUT = 5000;
export const MAXIMUM_EMBEDDED_TEXT_SIZE = 12582912;
export const REEF_REVIEW_OVERLAY_FIELD_SETTINGS = 'Reef Review Overlay Field Settings';